import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=117c72bd&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"
import style0 from "./edit.vue?vue&type=style&index=0&id=117c72bd&lang=scss&scoped=true&"
import style1 from "./edit.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117c72bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\uat\\platform-uat\\Platform-foundation-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('117c72bd')) {
      api.createRecord('117c72bd', component.options)
    } else {
      api.reload('117c72bd', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=117c72bd&scoped=true&", function () {
      api.rerender('117c72bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/role/edit.vue"
export default component.exports